import { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useQuery } from 'react-query'

import { isrClient } from '../../clients/ISRClient'
import { selectUserToken } from '../../store/user'

export function useISR() {
  const token = useSelector(selectUserToken, shallowEqual)

  const QUERY_KEY = useMemo(() => ['getPowerBIEmbedToken', token], [token])

  const { data, isLoading, isFetching, error, refetch } = useQuery(
    QUERY_KEY,
    () => {
      if (!token) throw new Error('err')
      return isrClient.getEmbedToken({ token })
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  return {
    error,
    isLoading,
    isFetching,
    isrData: data,
    refetch,
  }
}
